var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.reward_selection_campaigns.length > 0
        ? _c(
            "q-btn-dropdown",
            {
              attrs: { label: _vm.$t(_vm.getCampaignLabel), flat: "" },
              model: {
                value: _vm.show_campaigns,
                callback: function($$v) {
                  _vm.show_campaigns = $$v
                },
                expression: "show_campaigns"
              }
            },
            [
              _c(
                "q-list",
                { attrs: { link: "" } },
                _vm._l(_vm.campaignsList, function(item, index) {
                  return _vm.id_user_campaign_selected !== item.value
                    ? _c(
                        "q-item",
                        {
                          key: index,
                          nativeOn: {
                            click: function($event) {
                              return _vm.changeCampaign(item)
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-main",
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(_vm._s(item.title))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }